import { assert } from "tsafe";

import en from "./en.json";
import zhHansF from "./zh-Hans-F.json";
import zhHans from "./zh-Hans.json";
import vi from "./vi.json";
import id from "./id.json";

export const LANG = {
  enUS: "en",
  zhCN: "zh-Hans",
  zhTW: "zh-Hans-F",
  vi: "vi",
  system: "system",
  id: "id",
};
export const resources = {
  [LANG.zhCN]: { translation: zhHans },
  [LANG.zhTW]: { translation: zhHansF },
  [LANG.enUS]: { translation: en },
  [LANG.vi]: { translation: vi },
  [LANG.id]: { translation: id },
};
